{
  "name": "pia",
  "version": "4.1.0",
  "license": "GPLV3",
  "author": "ATNOS",
  "repository": "https://github.com/LINCnil/pia",
  "description": "Version Portable Outil PIA",
  "main": "electron/main.js",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "cypress open --config watchForFileChanges=false --browser chrome",
    "prod": "ng build --configuration production",
    "clean": "rimraf ./dist/",
    "format:write": "prettier src/**/*.{ts,json,md,scss} --write",
    "format:test": "prettier src/**/*.{ts,json,md,scss} --list-different",
    "extract-i18n": "ngx-translate-extract --input src --output ./src/assets/i18n/ --clean --sort --format namespaced-json",
    "compodoc": "compodoc -p src/tsconfig.app.json",
    "electron:start": "electron .",
    "electron:mac": "electron-builder -m",
    "electron:win": "electron-builder -w",
    "electron:linux": "electron-builder -l",
    "electron:publish-to-github": "electron-builder -mwl -p onTagOrDraft"
  },
  "husky": {
    "hooks": {
      "pre-commit": "pretty-quick --staged",
      "commit-msg": "commitlint -E HUSKY_GIT_PARAMS"
    }
  },
  "commitlint": {
    "extends": [
      "@commitlint/config-conventional"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.2",
    "@angular/common": "^20.3.14",
    "@angular/compiler": "^20.3.15",
    "@angular/core": "^20.3.2",
    "@angular/forms": "^20.3.2",
    "@angular/platform-browser": "^20.3.2",
    "@angular/platform-browser-dynamic": "^20.3.2",
    "@angular/router": "^20.3.2",
    "@angular/service-worker": "^20.3.2",
    "@electron-forge/cli": "^7.8.0",
    "@fortawesome/angular-fontawesome": "1.0.0",
    "@fortawesome/fontawesome-svg-core": "^6.7.2",
    "@fortawesome/free-brands-svg-icons": "^6.7.2",
    "@fortawesome/free-solid-svg-icons": "^6.7.2",
    "@ngx-translate/core": "^16",
    "@ngx-translate/http-loader": "^16",
    "@types/intro.js": "^2.4.8",
    "core-js": "^3.6.5",
    "cypress-file-upload": "^4.1.1",
    "cypress-localstorage-commands": "^1.3.1",
    "d3": "^7.8.5",
    "dotenv": "^8.2.0",
    "electron-squirrel-startup": "^1.0.1",
    "electron-updater": "^6.6.2",
    "file-saver": "^2.0.5",
    "foundation-sites": "^6.6.3",
    "html2canvas": "1.0.0",
    "html2pdf.js": "^0.10.1",
    "intro.js": "^2.9.3",
    "jspdf": "^2.5.1",
    "jszip": "^3.7.1",
    "ng2-pdfjs-viewer": "^25.0.9",
    "ngx-chips": "3.0.0",
    "normalize.css": "^8.0.1",
    "rxjs": "^7.8.2",
    "rxjs-compat": "^6.5.5",
    "save-svg-as-png": "^1.4.17",
    "tinymce": "^8.0.2",
    "tslib": "^2.0.3",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.3",
    "@angular/cli": "^20.3.3",
    "@angular/compiler-cli": "^20.3.2",
    "@commitlint/cli": "^11.0.0",
    "@commitlint/config-conventional": "^11.0.0",
    "@electron/notarize": "^3.0.1",
    "@types/jasmine": "~3.6.11",
    "@types/jasminewd2": "~2.0.10",
    "@types/node": "^22.18.6",
    "codelyzer": "^6.0.2",
    "commitlint": "^11.0.0",
    "cypress": "^15.3.0",
    "electron": "35.7.5",
    "electron-builder": "^26.0.12",
    "husky": "^4.0.10",
    "jasmine-core": "~3.6.0",
    "jasmine-spec-reporter": "~5.0.2",
    "karma": "~6.3.16",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~4.0.1",
    "karma-jasmine-html-reporter": "^1.5.4",
    "ng-packagr": "^20.3.0",
    "ngx-cypress-builder": "^1.0.2",
    "prettier": "^1.18.2",
    "pretty-quick": "^2.0.2",
    "sass": "^1.29.0",
    "ts-node": "~8.3.0",
    "tslint": "~6.1.3",
    "typescript": "^5.8.2"
  },
  "build": {
    "appId": "com.atnos.pia",
    "afterSign": "electron/notarize.js",
    "directories": {
      "buildResources": "electron/icons",
      "output": "electron/releases"
    },
    "publish": [
      "github"
    ],
    "mac": {
      "hardenedRuntime": true,
      "gatekeeperAssess": false,
      "icon": "electron/icons/icon.png",
      "entitlements": "electron/entitlements.mac.plist",
      "entitlementsInherit": "electron/entitlements.mac.plist",
      "category": "public.app.category.productivity",
      "target": {
        "target": "default",
        "arch": [
          "universal"
        ]
      }
    },
    "win": {
      "target": [
        {
          "target": "nsis",
          "arch": [
            "x64",
            "ia32"
          ]
        }
      ],
      "icon": "electron/icons/icon.png",
      "verifyUpdateCodeSignature": false
    },
    "linux": {
      "category": "Network"
    },
    "nsis": {
      "oneClick": false,
      "perMachine": true,
      "allowToChangeInstallationDirectory": true
    }
  },
  "packageManager": "yarn@4.10.3"
}
